import { render, staticRenderFns } from "./ManageFacility.vue?vue&type=template&id=a656b5a0"
import script from "./ManageFacility.vue?vue&type=script&lang=js"
export * from "./ManageFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports